
import { BaseContext } from '../../../../utils/basecontext';
import { ToneOptionViewImpl } from './toneoptionview';
import { ToneOptionCSSStyleImpl } from './toneoptioncss';
import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ToneDto } from '../../../../core/dto/tonedto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { ToneOptionAPIModelImpl, ToneOptionAPIModel } from './toneoptionapimodel';
import { ToneOptionsType } from '../../popup/tonedetailspopup/tonedetailspopupcomponent';
import { ToneRowOptionsPrivilage } from '../../../toolkit/toneoptions/tone/tonerowcomponent';

export interface ToneOptionComponentProps extends UIComponentProps
{
    tonePrivilage: ToneRowOptionsPrivilage;
    toneOptionType: ToneOptionsType;
    toneDto: ToneDto;
}
export interface ToneOptionComponentHandler extends UIComponentHandler
{
    addToWishlist(): void;
    onBuyToneClick():void;
}

export class ToneOptionComponent extends UIComponentImpl<ToneOptionComponentProps, UIComponentState, UIDataModel> implements ToneOptionComponentHandler
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToneOptionViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ToneOptionCSSStyleImpl(applicationContext);
    }   

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToneOptionAPIModelImpl(applicationContext, apiModelHandler);
    }

    addToWishlist(): void {
        (this.getAPIModel() as ToneOptionAPIModel).addToWishlist(this.props.toneDto, this.props.toneOptionType);
    }

    onBuyToneClick():void{
        (this.getView() as ToneOptionViewImpl).onBuyToneClicked();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptioncomponent.tsx